// Import all images using ES modules (Vite-compatible)

// team avatars
import anaAvatar from './../assets/images/avatar-ana.jpeg';
import pedroAvatar from './../assets/images/avatar-pedro.jpeg';
import marcoAvatar from './../assets/images/avatar-marco.jpeg';

//logos
import logoWithOuColor from './../assets/images/logo_without_color.png';
import logoWithColor from './../assets/images/logo_one_key_with_color.png';
import logoOneKeyWithOuColor from './../assets/images/logo_one_key_without_color.png';
import logoWithOuuText from './../assets/images/logo_without_text.png';
import logoWhiteTextBack from './../assets/images/logo_white_text_blacl.png';

//icons
import iconHouse from './../assets/images/icon_house.png';
import iconKey from './../assets/images/icon_check_in.png';
import iconServices from './../assets/images/icon_services.png';
import iconTeam from './../assets/images/icon_team.png';
import iconOneKey from './../assets/images/icon_one_key.png';

//patterns
import pattern from './../assets/images/pattern.png';

//other images
import  doorSecure from './../assets/images/door_secure.png';
import  mockPhone from './../assets/images/mock_phone.png';


import headlogo from './../assets/images/logo.png';
import headlogoBlue from './../assets/images/logo-blue.png';
import Star1 from './../assets/images/stars.png';
import SmokeImg1 from './../assets/images/smoke-img1.png';
import SmokeImg2 from './../assets/images/smoke-img2.png';
import ShootingStar from './../assets/images/shooting-star.png';
import Roket from './../assets/images/roket.png';
import DevelopImg from './../assets/images/design-development-img.png';
import LaunchImg from './../assets/images/testing-launching-img.png';

import Web1 from './../assets/images/web-development.png';
import Web2 from './../assets/images/web-design.png';
import Seo from './../assets/images/seo-marketing.png';
import Research from './../assets/images/research.png';
import Maintan from './../assets/images/maintanance.png';
import Support from './../assets/images/support.png';
import ServiceImg from './../assets/images/service-img.png';
import TestImg1 from './../assets/images/testimonial-img1.jpg';
import TestImg2 from './../assets/images/testimonial-img2.jpg';
import TestImg3 from './../assets/images/testimonial-img3.jpg';
import Quote from './../assets/images/quote.png';
import ConatctImg from './../assets/images/contact-img.png';
import BlogImg1 from './../assets/images/blog-img1.jpg';
import BlogImg2 from './../assets/images/blog-img2.jpg';
import BlogImg3 from './../assets/images/blog-img3.jpg';
import BlogImg4 from './../assets/images/blog-img4.jpg';
import BlogImg5 from './../assets/images/blog-img5.jpg';
import BlogImg6 from './../assets/images/blog-img6.jpg';
import BlogImg7 from './../assets/images/blog-img7.jpg';
import CounterImg from './../assets/images/counter-img.png';
import ExperienceImg from './../assets/images/experience-img.png';
import TeamImg1 from './../assets/images/team-img1.jpg';
import TeamImg2 from './../assets/images/team-img2.jpg';
import TeamImg3 from './../assets/images/team-img3.jpg';
import TeamImg4 from './../assets/images/team-img4.jpg';
import TeamImg5 from './../assets/images/team-img5.jpg';
import TeamImg6 from './../assets/images/team-img6.jpg';
import FaqImg from './../assets/images/faq-img.png';
import recent1 from './../assets/images/recent-post-img1.jpg';
import recent2 from './../assets/images/recent-post-img2.jpg';
import recent3 from './../assets/images/recent-post-img3.jpg';
import recent4 from './../assets/images/recent-post-img4.jpg';
import gallery1 from './../assets/images/gallery-img1.jpg';
import gallery2 from './../assets/images/gallery-img2.jpg';
import gallery3 from './../assets/images/gallery-img3.jpg';
import gallery4 from './../assets/images/gallery-img4.jpg';
import gallery5 from './../assets/images/gallery-img5.jpg';
import gallery6 from './../assets/images/gallery-img6.jpg';
import largeGallery1 from './../assets/images/gallery-large-img1.jpg';
import largeGallery2 from './../assets/images/gallery-large-img2.jpg';
import largeGallery3 from './../assets/images/gallery-large-img3.jpg';
import largeGallery4 from './../assets/images/gallery-large-img4.jpg';
import largeGallery5 from './../assets/images/gallery-large-img5.jpg';
import largeGallery6 from './../assets/images/gallery-large-img6.jpg';
import advertising from './../assets/images/advertising-img.jpg';
import Comment1 from './../assets/images/detail-comment-img1.jpg';
import Comment2 from './../assets/images/detail-comment-img2.jpg';
import Comment3 from './../assets/images/detail-comment-img3.jpg';
import Quoto from './../assets/images/double-quote-2.png';
import CallIcon from './../assets/images/call-icon.png';
import MapIcon from './../assets/images/map-icon.png';
import MailIcon from './../assets/images/mail-icon.png';

export const IMAGES = {
    logoWithOuColor,
    logoOneKeyWithOuColor,
    logoWithOuuText,
    logoWithColor,
    logoWhiteTextBack,
    iconHouse,
    iconKey,
    iconServices,
    iconTeam,
    pattern,
    doorSecure,
    mockPhone,
    iconOneKey,
    anaAvatar,
    pedroAvatar,
    marcoAvatar,

    headlogo,
    headlogoBlue,
    Star1,
    SmokeImg1,
    SmokeImg2,
    ShootingStar,
    Roket,
    DevelopImg,
    LaunchImg,
    Web1,
    Web2,
    Seo,
    Research,
    Maintan,
    Support,
    ServiceImg,
    TestImg1,
    TestImg2,
    TestImg3,
    Quote,
    ConatctImg,
    BlogImg1,
    BlogImg2,
    BlogImg3,
    BlogImg4,
    BlogImg5,
    BlogImg6,
    BlogImg7,
    CounterImg,
    ExperienceImg,
    TeamImg1,
    TeamImg2,
    TeamImg3,
    TeamImg4,
    TeamImg5,
    TeamImg6,
    FaqImg,
    recent1,
    recent2,
    recent3,
    recent4,
    gallery1,
    gallery2,
    gallery3,
    gallery4,
    gallery5,
    gallery6,
    largeGallery1,
    largeGallery2,
    largeGallery3,
    largeGallery4,
    largeGallery5,
    largeGallery6,
    advertising,
    Comment1,
    Comment2,
    Comment3,
    Quoto,
    CallIcon,
    MapIcon,
    MailIcon,
}